import { useEffect, useState } from "react";

/** true only after `active` has stayed true for `ms`; short loads never flash. */
export function useDelayed(active: boolean, ms = 200): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) { setShown(false); return; }
    if (ms <= 0) { setShown(true); return; }
    const t = setTimeout(() => setShown(true), ms);
    return () => clearTimeout(t);
  }, [active, ms]);
  return active && shown;
}
